import { useEffect, useState } from "react";
import { BsExclamationLg } from "react-icons/bs";

const LogoutAlert = ({ handleLogoff, handleStaySignedIn }) => {
  const [secondsLeft, setSecondsLeft] = useState(0);

  // Effect to retrieve timer value from localStorage on component mount
  useEffect(() => {
    const timerFromStorage = JSON.parse(localStorage.getItem("logoutTimer"));
    if (timerFromStorage) {
      setSecondsLeft(timerFromStorage);
    }
  }, []);

  // Effect to handle countdown and trigger logout when time expires
  useEffect(() => {
    const timer = setInterval(() => {
      if (secondsLeft > 0) {
        setSecondsLeft((prevSeconds) => prevSeconds - 1);
      }
      if (secondsLeft === 0) {
        handleLogoff();
      }
    }, 1000);

    // Save timer to localStorage
    localStorage.setItem("logoutTimer", JSON.stringify(secondsLeft));

    // Cleanup function to clear interval on component unmount
    return () => clearInterval(timer);
  }, [secondsLeft]);

  // JSX rendering of the component
  return (
    <section
      className="d-flex mt-2 mb-1"
      style={{ border: "2px solid #840f03" }}
    >
      {/* Icon indicating the warning */}
      <aside
        className="center-alignment px-2"
        style={{ background: "#840f03" }}
      >
        <BsExclamationLg className="text-white fs-1" />
      </aside>
      {/* Main content of the warning */}
      <main className="p-4 d-flex flex-column">
        <div className="d-flex flex-column justify-content-center align-items-start text-start">
          {/* Title of the warning */}
          <h3 className="fw-600 fs-25" style={{ color: "#373b44" }}>
            Time out warning
          </h3>
          {/* Message indicating automatic logout */}
          <p className="fw-600 fs-18 mt-3" style={{ color: "#373b44" }}>
            There has been no activity. For your security, you will be
            automatically logged off
            <br /> in {secondsLeft} seconds.
          </p>
        </div>
        {/* Buttons for user action */}
        <div className="center-alignment gap-3 my-5">
          {/* Button to stay logged in */}
          <button
            className="btn-logout btn-logout-v1"
            onClick={() => {
              // Update timer in localStorage and handle stay signed in action
              localStorage.setItem("logoutTimer", 60);
              handleStaySignedIn();
            }}
          >
            Stay logged in
          </button>
          {/* Button to log off */}
          <button className="btn-logout btn-logout-v2" onClick={handleLogoff}>
            Log off
          </button>
        </div>
      </main>
    </section>
  );
};

export default LogoutAlert;
